<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
import services from 'services';

export default {
  mounted() {
    services.authService.listenUserState((user) => {
      if (user) {
        this.$store.dispatch('permissions/fetchRolePermissions');
        this.$store.dispatch('auth/fetchCurrentUserProfile', user.uid);
      }
    });
  },
  data() {
    return {
      isLoading: false,
    };
  },
};
</script>

<style lang="stylus">
@import '~@/assets/css/main.styl';
</style>
